<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            :alt="$t('pages.passwordRecoveryIllustration')"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Forgot password-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            class="mb-1 font-weight-bold"
            title-tag="h2"
          >
            {{ $t('pages.forgotPassword') }} <span aria-hidden="true">🔒</span>
          </b-card-title>

          <template v-if="sentMessage">
            <b-card-text class="mb-1">
              {{ sentMessage }}
            </b-card-text>
            <b-card-text class="mb-2 text-muted">
              {{ $t('pages.checkYourInboxAndSpamFolderTheLinkIn') }}
            </b-card-text>
          </template>

          <template v-else>
            <b-card-text class="mb-2">
              {{ $t('pages.enterYourEmailAndWeLlSendYouA') }}
            </b-card-text>

            <validation-observer
              ref="forgotPasswordForm"
              #default="{ invalid }"
            >
              <b-form
                class="auth-forgot-password-form mt-2"
                @submit.prevent="sendLink"
              >
                <b-form-group
                  :label="$t('pages.email')"
                  label-for="forgot-password-email"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('pages.email')"
                    vid="email"
                    rules="required|email"
                  >
                    <b-form-input
                      id="forgot-password-email"
                      v-model="userEmail"
                      :state="errors.length > 0 ? false : null"
                      name="forgot-password-email"
                      placeholder="john@example.com"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-button
                  type="submit"
                  variant="primary"
                  block
                  :disabled="invalid || isSubmitting"
                >
                  {{ $t('pages.sendLink') }}
                </b-button>
              </b-form>
            </validation-observer>
          </template>

          <b-card-text class="text-center mt-2">
            <b-link :to="{ name: 'page-login' }">
              <feather-icon icon="ChevronLeftIcon" />
              {{ $t('pages.backToLogin') }}
            </b-link>
          </b-card-text>
        </b-col>
      </b-col>
      <!-- /Forgot password-->
    </b-row>
  </div>
</template>

<script>
import i18n from '@/libs/i18n'

/* eslint-disable global-require */
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BButton,
  BCardText,
  BCardTitle,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BImg,
  BLink,
  BRow,
} from 'bootstrap-vue'
import { email, required } from '@validations'
import store from '@/store/index'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      userEmail: '',
      isSubmitting: false,
      sentMessage: '',
      sideImg: require('@/assets/images/pages/forgot-password-v2.svg'),

      // validation rules
      required,
      email,
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/forgot-password-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  created() {
    this.hideLoading()
  },
  methods: {
    sendLink() {
      this.$refs.forgotPasswordForm.validate().then(success => {
        if (!success) {
          return
        }

        this.isSubmitting = true
        this.showLoading()
        this.$http
          .post('/api/auth/forgot-password', { email: this.userEmail })
          .then(response => {
            this.sentMessage = response.data.message
          })
          .catch(errors => {
            this.alertApiError(errors, i18n.t('pages.couldNotSendTheLinkPleaseTryAgain'))
          })
          .finally(() => {
            this.isSubmitting = false
            this.hideLoading()
          })
      })
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
